import Model from './Model'

export default class EntityModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'entities'
  }
}
